import { Navigate } from "react-router-dom";

export function ProtectedRoute({ element, isAllowed }) {
  return isAllowed ? element : <Navigate to="/unauthorized" />;
}
